module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec01_pc_10452d4f62f57016830672119bf9c870.jpg";